import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAuth } from 'auth/AuthProvider'
import { reqAddDeliveryAddress, reqUpdateDeliveryAddress } from 'client/ClientRequests'
import { IDeliveryAddress } from 'client/IClientInfo'
import React, { useCallback, useEffect, useState } from 'react'
import DeliveryAddressForm from './DeliveryAddressForm'

interface IDeliveryAddressPickerProps {
  onSelect: (delivAddrId: number) => void
  defaultValue: number | null
}

const DeliveryAddressPicker: React.FC<IDeliveryAddressPickerProps> = ({
  onSelect,
  defaultValue,
}) => {
  const auth = useAuth()
  const [addresses, setAddresses] = useState<IDeliveryAddress[]>(
    auth.user?.addresses || []
  )
  const [address, setAddress] = useState<IDeliveryAddress | null>(null)
  const [isEdit, setIsEdit] = useState(false)

  useEffect(() => {
    if (auth.user) {
      let address_ = null

      if (defaultValue && auth.user) {
        address_ = addresses.find(
          (deliv_addr) => deliv_addr.deliv_addr_id === defaultValue
        )
      }

      if (address_) {
        setAddress(address_)
      } else {
        setAddress(addresses[0])
      }
    }
  }, [auth, defaultValue, addresses])

  const handleSelect = useCallback(
    (event: React.ChangeEvent<HTMLSelectElement>) => {
      const newValue = parseInt(event.target.value)
      onSelect(newValue)
      const address_ = addresses.find(
        (deliv_addr) => deliv_addr.deliv_addr_id === newValue
      )

      if (address_) {
        setAddress(address_)
      }

      setIsEdit(false)
    },
    [addresses, onSelect]
  )

  const handleAddNewAddress = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      event.preventDefault()
      setIsEdit(true)
      setAddress(null)
    },
    []
  )

  // const handleEdit = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
  //   event.preventDefault()
  //   setIsEdit(true)
  // }, [])

  const handleUpdateAddress = useCallback(
    (address: IDeliveryAddress) => {
      reqUpdateDeliveryAddress(address, (newAddress) => {
        if (newAddress) {
          setAddress(newAddress)
          const idx = addresses.findIndex(
            (deliv_addr) => deliv_addr.deliv_addr_id === newAddress.deliv_addr_id
          )

          if (idx !== -1) {
            addresses[idx] = newAddress
            setAddresses([...addresses])
          }
          setIsEdit(false)
        }
      })
    },
    [addresses]
  )

  const handleCreateAddress = useCallback(
    (address: IDeliveryAddress) => {
      reqAddDeliveryAddress(address, (newAddress) => {
        if (newAddress) {
          setAddress(newAddress)
          onSelect(newAddress.deliv_addr_id)
          setIsEdit(false)

          const newAddresses = [...addresses, newAddress]
          setAddresses(newAddresses)
          if (auth.user) {
            auth.user.addresses = newAddresses
          }
        }
      })
    },
    [auth, addresses, onSelect]
  )

  return (
    <div>
      <div className='d-flex gap-3'>
        <select
          className='form-control input-text'
          style={{ width: '100%' }}
          onChange={handleSelect}
          value={address?.deliv_addr_id}
        >
          {addresses.map((item) => (
            <option key={item.deliv_addr_id} value={item.deliv_addr_id}>
              г. {item.city_name}, ул. {item.street}, д. {item.building}
              {item.flat && ', кв. ' + item.flat}
              {item.entrance && ', подъезд ' + item.entrance}
              {item.floor ? ', этаж ' + item.floor : ''}
            </option>
          ))}
        </select>
        {!isEdit && (
          <>
            {/* <a href='/#/' onClick={handleEdit} className='my-link'>
              <FontAwesomeIcon icon={faEdit} size='lg' />
            </a> */}
            <a href='/#/' onClick={handleAddNewAddress} className='my-link'>
              <FontAwesomeIcon icon={faPlusCircle} size='lg' />
            </a>
          </>
        )}
      </div>

      {isEdit && (
        <div className='pl-dynamic'>
          {address ? (
            <DeliveryAddressForm
              key='update'
              address={address}
              onAccept={handleUpdateAddress}
              onCancel={() => {
                setIsEdit(false)
              }}
            />
          ) : (
            <DeliveryAddressForm
              key='create'
              address={null}
              onAccept={handleCreateAddress}
              onCancel={() => {
                setIsEdit(false)
              }}
            />
          )}
        </div>
      )}
    </div>
  )
}
export default DeliveryAddressPicker
